<template>
  <div class="bg-challenge-dark">
    <div class="container text-white">
      <div class="py-5 text-center">
        <img class="d-block mx-auto mb-4" src="../assets/logo.webp">
        <div v-if="loadingPlan">
          <div class="text-center">
            <b-spinner variant="light" label="Spinning"></b-spinner>
            <h6 class="mb-0 mt-2 font-weight-bold text-light">Carregando...</h6>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8" v-if="plan">
          <p class="challenge-price-text-1 mb-0">Tudo por:</p>
          <p class="challenge-price-text-2" v-if="payment.type === 'CREDIT_CARD' && plan.card">
            {{installments}}X R$ {{ formatMoney(((cardDisplayTotal || 0) / installments), 2) }}
          </p>
          <p class="challenge-price-text-2" v-if="payment.type === 'PIX' && plan.pix">
            1X R$ {{ formatMoney((pixDisplayTotal || 0), 2) }}
          </p>
          

          <div class="card challenge-card p-3" v-if="loading">
            <div class="text-center">
              <b-spinner variant="light" label="Spinning"></b-spinner>
              <h6 class="mb-0 mt-2 font-weight-bold text-light">Carregando...</h6>
            </div>
          </div>

          <div class="row card challenge-card" v-if="step === 'data' && !loading">
            <form class="challenge-text needs-validation p-3" @submit.prevent="changeStep('payment')">
              <h2 class="challenge-form-heading challenge-text">Comece aqui</h2>

              <div class="row px-3">
                <div class="col-md-6 mb-3">
                  <label for="firstName">Seu Nome</label>
                  <input type="text" class="form-control challenge-form-control" id="firstName" placeholder="" value="" required="" v-model="account.name" @input="maybeTrackInitiateCheckout">
                  <div class="invalid-feedback">
                    Valid first name is required.
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label for="email">Seu e-mail</label>
                  <div class="input-group">
                    <input type="text" class="form-control challenge-form-control" id="email" placeholder="" required="" autocomplete="username" v-model="account.email" @input="maybeTrackInitiateCheckout">
                    <div class="invalid-feedback">
                      O email não pode ser vazio.
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label for="cpf">CPF</label>
                  <the-mask type="text" id="cpf" class="form-control challenge-form-control" placeholder="" value="" required="" v-model="account.cpf" :mask="'###.###.###-##'" :masked="false" @input="maybeTrackInitiateCheckout" />
                  <div class="invalid-feedback">
                    CPF necessário
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label for="phone">Telefone</label>
                  <the-mask
                    type="text"
                    class="form-control challenge-form-control"
                    id="phone" placeholder=""
                    value=""
                    required=""
                    v-model="account.phoneNumber"
                    :mask="['(##) ####-####', '(##) #####-####']"
                    :masked="false"
                    @input="maybeTrackInitiateCheckout"
                  />
                  <div class="invalid-feedback">
                    Telefone necessário
                  </div>
                </div>
              </div>
  
              <div class="row px-3">
              </div>

              <div class="row px-3 mt-2" v-if="plan">
                <div class="col-12 mb-2">
                  <label class="challenge-label">Tipo de Pagamento:</label>
                </div>
              </div>

              <div class="row px-3 mt-2" v-if="plan">
                <div class="col-md-6 mb-3" v-if="plan.card && plan.card.available">
                  <div
                    class="challenge-pay-option"
                    :class="{ active: payment.type === 'CREDIT_CARD' }"
                    role="button"
                    tabindex="0"
                    @click="payment.type = 'CREDIT_CARD'"
                    @keypress.enter="payment.type = 'CREDIT_CARD'"
                  >
                    <span class="challenge-pay-icon">
                      <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="credit-card" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                        <path fill="currentColor" d="M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"></path>
                      </svg>
                    </span>
                    <span class="challenge-pay-text">Cartão de Crédito</span>
                  </div>
                </div>
                <div class="col-md-6 mb-3" v-if="plan.pix && plan.pix.available">
                  <div
                    class="challenge-pay-option"
                    :class="{ active: payment.type === 'PIX' }"
                    role="button"
                    tabindex="0"
                    @click="payment.type = 'PIX'"
                    @keypress.enter="payment.type = 'PIX'"
                  >
                    <span class="challenge-pay-icon">
                      <svg viewBox="0 0 166 166" xmlns="http://www.w3.org/2000/svg">
                        <path d="M128.886 126.429C122.402 126.429 116.304 123.904 111.719 119.321L86.9305 94.5328C85.1908 92.7877 82.1569 92.7931 80.4173 94.5328L55.5383 119.412C50.9529 123.994 44.8548 126.519 38.3704 126.519H33.4857L64.8802 157.914C74.6853 167.718 90.5823 167.718 100.387 157.914L131.873 126.429H128.886Z" fill="currentColor"></path>
                        <path d="M38.3705 38.7476C44.8549 38.7476 50.953 41.2731 55.5376 45.8562L80.4166 70.739C82.2083 72.5308 85.1342 72.5385 86.9306 70.7367L111.719 45.9464C116.304 41.3633 122.402 38.8385 128.887 38.8385H131.872L100.388 7.35388C90.5824 -2.45126 74.6854 -2.45126 64.8803 7.35388L33.4866 38.7476H38.3705Z" fill="currentColor"></path>
                        <path d="M157.914 64.8806L138.888 45.8541C138.469 46.022 138.015 46.1269 137.537 46.1269H128.887C124.414 46.1269 120.036 47.9404 116.876 51.1026L92.0874 75.8914C89.7686 78.2109 86.7207 79.3722 83.6752 79.3722C80.6273 79.3722 77.5818 78.2109 75.2622 75.8937L50.3809 51.0124C47.2204 47.8503 42.8433 46.0368 38.3705 46.0368H27.7337C27.2805 46.0368 26.8561 45.9295 26.4558 45.7787L7.35385 64.8806C-2.45128 74.685 -2.45128 90.582 7.35385 100.388L26.455 119.489C26.8553 119.338 27.2805 119.231 27.7337 119.231H38.3705C42.8433 119.231 47.2204 117.417 50.3809 114.255L75.2599 89.3763C79.7567 84.8834 87.5952 84.8811 92.0874 89.3787L116.876 114.164C120.036 117.327 124.414 119.141 128.887 119.141H137.537C138.016 119.141 138.469 119.245 138.888 119.413L157.914 100.388C167.719 90.582 167.719 74.685 157.914 64.8806Z" fill="currentColor"></path>
                      </svg>
                    </span>
                    <span class="challenge-pay-text">PIX</span>
                  </div>
                </div>
              </div>

              <div class="row px-3" v-if="payment.type === 'CREDIT_CARD' && plan && plan.card && plan.card.value">
                <div class="col-12 mb-2">
                  <label for="installments" class="challenge-label">Quantidade de Parcelas:</label>
                  <select id="installments" class="form-control challenge-payment-select challenge-form-control" v-model="installments" :disabled="sidebarDisabled">
                    <option v-for="index in 5" :key="index" :value="index">{{index}}x R$ {{ formatMoney(((cardDisplayTotal || 0) / index), 2) }}</option>
                  </select>
                </div>
              </div>

              <div class="col-12 m-auto challenge-text">
                Ao efetuar a compra, você aceita os <b-link class="text-secondary" v-b-modal.modal-1>termos de uso da plataforma</b-link>.
              </div>

              <div class="col-md-4 m-auto p-5">
                <button class="btn btn-secondary btn-lg btn-block text-center" type="submit">Próximo </button>
              </div>
            </form>
          </div>

          <div class="row card challenge-card" v-if="step === 'payment' && !loading">
            <div class="row px-3 mt-2" v-if="plan">
              <div class="col-12 mb-2">
                <label class="challenge-label">Tipo de Pagamento:</label>
              </div>
            </div>
            <div class="row px-3 mt-2" v-if="plan">
              <div class="col-md-6 mb-3" v-if="plan.card && plan.card.available">
                <div
                  class="challenge-pay-option"
                  :class="{ active: payment.type === 'CREDIT_CARD' }"
                  role="button"
                  tabindex="0"
                  @click="payment.type = 'CREDIT_CARD'"
                  @keypress.enter="payment.type = 'CREDIT_CARD'"
                >
                  <span class="challenge-pay-icon">
                    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="credit-card" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                      <path fill="currentColor" d="M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"></path>
                    </svg>
                  </span>
                  <span class="challenge-pay-text">Cartão de Crédito</span>
                </div>
              </div>
              <div class="col-md-6 mb-3" v-if="plan.pix && plan.pix.available">
                <div
                  class="challenge-pay-option"
                  :class="{ active: payment.type === 'PIX' }"
                  role="button"
                  tabindex="0"
                  @click="payment.type = 'PIX'"
                  @keypress.enter="payment.type = 'PIX'"
                >
                  <span class="challenge-pay-icon">
                    <svg viewBox="0 0 166 166" xmlns="http://www.w3.org/2000/svg">
                      <path d="M128.886 126.429C122.402 126.429 116.304 123.904 111.719 119.321L86.9305 94.5328C85.1908 92.7877 82.1569 92.7931 80.4173 94.5328L55.5383 119.412C50.9529 123.994 44.8548 126.519 38.3704 126.519H33.4857L64.8802 157.914C74.6853 167.718 90.5823 167.718 100.387 157.914L131.873 126.429H128.886Z" fill="currentColor"></path>
                      <path d="M38.3705 38.7476C44.8549 38.7476 50.953 41.2731 55.5376 45.8562L80.4166 70.739C82.2083 72.5308 85.1342 72.5385 86.9306 70.7367L111.719 45.9464C116.304 41.3633 122.402 38.8385 128.887 38.8385H131.872L100.388 7.35388C90.5824 -2.45126 74.6854 -2.45126 64.8803 7.35388L33.4866 38.7476H38.3705Z" fill="currentColor"></path>
                      <path d="M157.914 64.8806L138.888 45.8541C138.469 46.022 138.015 46.1269 137.537 46.1269H128.887C124.414 46.1269 120.036 47.9404 116.876 51.1026L92.0874 75.8914C89.7686 78.2109 86.7207 79.3722 83.6752 79.3722C80.6273 79.3722 77.5818 78.2109 75.2622 75.8937L50.3809 51.0124C47.2204 47.8503 42.8433 46.0368 38.3705 46.0368H27.7337C27.2805 46.0368 26.8561 45.9295 26.4558 45.7787L7.35385 64.8806C-2.45128 74.685 -2.45128 90.582 7.35385 100.388L26.455 119.489C26.8553 119.338 27.2805 119.231 27.7337 119.231H38.3705C42.8433 119.231 47.2204 117.417 50.3809 114.255L75.2599 89.3763C79.7567 84.8834 87.5952 84.8811 92.0874 89.3787L116.876 114.164C120.036 117.327 124.414 119.141 128.887 119.141H137.537C138.016 119.141 138.469 119.245 138.888 119.413L157.914 100.388C167.719 90.582 167.719 74.685 157.914 64.8806Z" fill="currentColor"></path>
                    </svg>
                  </span>
                  <span class="challenge-pay-text">PIX</span>
                </div>
              </div>
            </div>
            <div class="row px-3" v-if="payment.type === 'CREDIT_CARD' && plan && plan.card && plan.card.value">
              <div class="col-12 mb-2">
                <label for="installments-2" class="challenge-label">Quantidade de Parcelas:</label>
                <select id="installments-2" class="form-control challenge-payment-select challenge-form-control" v-model="installments" :disabled="sidebarDisabled">
                  <option v-for="index in 5" :key="index" :value="index">{{index}}x R$ {{ formatMoney(((cardDisplayTotal || 0) / index), 2) }}</option>
                </select>
              </div>
            </div>

            <div class="p-3" v-if="payment.type === 'PIX' && paymentInfo">
              <p class="challenge-copy-and-paste" @click="copyToClipboard(paymentInfo.copyAndPaste)">
                <span class="bold">Copia e cola:</span> <span id="copy-and-paste">{{ paymentInfo.copyAndPaste }}</span>
              </p>
              <div class="text-center">
                <img :src="'data:image/png;base64,' + paymentInfo.qrCode" />
              </div>
              <p class="challenge-text mt-3">Após efetuar o pagamento clique nesse link e vá para a tela de login:</p>
              <div class="text-right">
                <a class="btn btn-secondary" href="/login">Ir para Login</a>
              </div>
            </div>
            <form class="challenge-text needs-validation p-3" @submit.prevent="register" v-if="payment.type === 'CREDIT_CARD'">

              <div class="row px-3">
                <div class="col-md-12 mb-3 mt-2">
                  <label for="card">Nome no Cartão</label>
                  <input type="text" class="form-control challenge-form-control" id="card" placeholder="" value="" required="" v-model="payment.name">
                  <div class="invalid-feedback">
                    Valid name is required.
                  </div>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="phone">Número do Cartão</label>
                  <the-mask
                    type="text"
                    class="form-control challenge-form-control"
                    id="phone" 
                    placeholder=""
                    value=""
                    required=""
                    v-model="payment.number"
                    :mask="['#### #### #### ####']"
                    :masked="false"
                  />
                  <div class="invalid-feedback">
                    Número do cartão necessário
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <label for="card">Validade (Mês)</label>
                  <input type="text" class="form-control challenge-form-control" id="card" placeholder="" value="" required="" v-model="payment.expiryMonth">
                  <div class="invalid-feedback">
                    Valid month is required.
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <label for="card">Validade (Ano)</label>
                  <input type="text" class="form-control challenge-form-control" id="card" placeholder="" value="" required="" v-model="payment.expiryYear">
                  <div class="invalid-feedback">
                    Valid year is required.
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <label for="card">CVV</label>
                  <input type="text" class="form-control challenge-form-control" id="card" placeholder="" value="" required="" v-model="payment.ccv">
                  <div class="invalid-feedback">
                    CVV is required.
                  </div>
                </div>

                <div class="col-12 m-auto challenge-text">
                  Ao finalizar o cadastro, você aceita os <b-link class="text-secondary" v-b-modal.modal-1>termos de uso da plataforma</b-link>.
                </div>

                <div class="col-md-4 m-auto p-5">
                  <button class="btn btn-secondary btn-lg btn-block text-center" type="submit">Finalizar Cadastro </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="col-md-4" v-if="plan"> <!-- Sidebar-->
          <div class="challenge-top-spacer"></div>
          <div class="card challenge-card p-3">
            <div class="mb-3">
              <div v-if="!loadingPlan" class="challenge-side-plan-name">
                <strong>
                  <span class="challenge-plan-title" v-if="plan">{{ plan.name }}</span>
                  <span class="challenge-plan-title" v-else>Produto indisponível no momento.</span>
                </strong>
              </div>
              <div class="challenge-side-plan-price">
                <span class="challenge-plan-title" v-if="plan && payment.type === 'CREDIT_CARD' && plan.card">
                  {{installments}}X R$ {{ formatMoney(((cardDisplayTotal || 0) / installments), 2) }}
                </span>
                <span class="challenge-plan-title" v-if="plan && payment.type === 'PIX' && plan.pix">
                  1X R$ {{ formatMoney((pixDisplayTotal || 0), 2) }}
                </span>
              </div>
            </div>
            <!-- <div class="form-group mt-4">
              <label for="challenge-coupon">CUPOM</label>
              <div class="input-group">
                <input
                  id="challenge-coupon"
                  type="text"
                  class="form-control challenge-form-control"
                  v-model="coupon"
                  placeholder="Digite seu cupom"
                  autocomplete="off"
                  :disabled="sidebarDisabled"
                />
                <div class="input-group-append">
                  <button type="button" class="btn btn-secondary" @click="applyCoupon" :disabled="sidebarDisabled">Aplicar</button>
                </div>
              </div>
            </div> -->
            <div class="row mt-3" v-if="plan && plan.checkoutItems && plan.checkoutItems.length">
                <div class="col-12 mb-3">
                  <label class="challenge-addons-label">Itens Adicionais</label>
                  <div>
                    <b-form-checkbox
                      v-for="item in plan.checkoutItems"
                      :key="item.id"
                      v-model="selectedCheckoutItems"
                      :value="item.id"
                      class="challenge-addon"
                    >
                      <span class="challenge-addon-text">{{ item.name }} - R$ {{ formatMoney(item.value || 0, 2) }}</span>
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
              <!-- <div class="mt-2 text-success d-flex align-items-center justify-content-between">
                <span v-if="appliedCoupon && appliedCoupon.discountPercentage">
                  Desconto: {{ appliedCoupon.discountPercentage }}%
                </span>
                <span v-else-if="appliedCoupon && appliedCoupon.discountValue">
                  Desconto: R$ {{ formatMoney(appliedCoupon.discountValue, 2) }}
                </span>
                <span v-else>
                  Desconto aplicado.
                </span>
                <button type="button" class="btn btn-outline-light btn-sm ml-3" @click="removeCoupon">Remover</button>
              </div> -->
              <div class="mt-3">
                <div class="d-flex justify-content-between challenge-text">
                  <span>Desafio</span>
                  <strong>R$ {{ formatMoney(planBaseValue, 2) }}</strong>
                </div>
                <div class="d-flex justify-content-between challenge-text" v-if="selectedCheckoutItemsTotal > 0">
                  <span>Items Adicionais <i class="fa fa-info-circle text-info" aria-hidden="true" v-b-tooltip.hover :title="selectedCheckoutItemsNames"></i></span>
                  <strong>R$ {{ formatMoney(selectedCheckoutItemsTotal, 2) }}</strong>
                </div>
                <div class="d-flex justify-content-between challenge-text">
                  <span>Valor Total <i v-if="payment.type === 'CREDIT_CARD'" class="fa fa-info-circle text-info" aria-hidden="true" v-b-tooltip.hover title="Taxas do cartão serão repassadas."></i></span>
                  <strong>R$ {{ formatMoney(totalBeforeDiscount, 2) }}</strong>
                </div>
                <!-- <div class="d-flex justify-content-between challenge-text">
                  <span>Valor com Desconto</span>
                  <strong>R$ {{ formatMoney(totalAfterDiscount, 2) }}</strong>
                </div> -->
                <div class="mt-3" v-if="step === 'payment' && !isAuth">
                  <button type="button" class="btn btn-secondary btn-block" @click="step = 'data'">Voltar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <b-modal id="modal-1" title="TERMOS DE USO DOS SERVIÇOS ORIENTA LEGAL LTDA.">
          <TermsAndConditions />
        </b-modal>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from 'components/Footer';
import TermsAndConditions from 'components/TermsAndConditions';
// import { checkCoupon } from '@/services/coupons';
import { getCheckoutPlan } from '@/services/plans';
import axios from 'axios';
import store from 'store';

export default {
  name: 'ChallengeCheckout',
  data() {
    return {
      loading: false,
      _initiatedCheckoutTracked: false,
      loadingPlan: false,
      stateOptions: [
        { value: null, text: 'Por favor, selecione uma opção' },
        { value: 'AC', text: 'Acre' },
        { value: 'AL', text: 'Alagoas' },
        { value: 'AP', text: 'Amapá' },
        { value: 'AM', text: 'Amazonas' },
        { value: 'BA', text: 'Bahia' },
        { value: 'CE', text: 'Ceará' },
        { value: 'DF', text: 'Distrito Federal' },
        { value: 'ES', text: 'Espírito Santo' },
        { value: 'GO', text: 'Goiás' },
        { value: 'MA', text: 'Maranhão' },
        { value: 'MT', text: 'Mato Grosso' },
        { value: 'MS', text: 'Mato Grosso do Sul' },
        { value: 'MG', text: 'Minas Gerais' },
        { value: 'PA', text: 'Pará' },
        { value: 'PB', text: 'Paraíba' },
        { value: 'PR', text: 'Paraná' },
        { value: 'PE', text: 'Pernambuco' },
        { value: 'PI', text: 'Piauí' },
        { value: 'RJ', text: 'Rio de Janeiro' },
        { value: 'RN', text: 'Rio Grande do Norte' },
        { value: 'RS', text: 'Rio Grande do Sul' },
        { value: 'RO', text: 'Rondônia' },
        { value: 'RR', text: 'Roraima' },
        { value: 'SC', text: 'Santa Catarina' },
        { value: 'SP', text: 'São Paulo' },
        { value: 'SE', text: 'Sergipe' },
        { value: 'TO', text: 'Tocantins' },
      ],
      account: {
        name: '',
        email: '',
        phoneNumber: '',
        state: '',
        city: '',
        neighborhood: '',
        street: '',
        streetNumber: '',
        zipcode: '',
        password: '',
        confirmPassword: ''
      },
      payment: {
        name: '',
        number: '',
        expiryMonth: '',
        expiryYear: '',
        ccv: '',
        type: 'CREDIT_CARD'
      },
      termsAndConditions: 'not_accepted',
      plan: null,
      installments: 1,
      step: 'data',
      // coupon: '',
      // appliedCoupon: null,
      userIP: '',
      selectedCheckoutItems: [],
      paymentInfo: null,
    };
  },
  async created() {
    await Promise.all([this.fetchPlan(), this.fetchIP()]);
    if (store.getters.isAuthenticated) {
      this.step = 'payment';
    }
  },
  mounted() {
    this._trackingNodes = [];
    this.injectGtm('GTM-NGXN4CD4');
    this.injectGa4('G-HVMGYQWGSZ');
    // Meta Pixel agora vem do plugin global metaPixel.js (init unica vez
    // baseado em VUE_APP_META_PIXEL_ID). PageView eh disparado
    // automaticamente pelo router.afterEach + init do plugin.
  },
  beforeDestroy() {
    if (Array.isArray(this._trackingNodes)) {
      this._trackingNodes.forEach(node => {
        if (node && node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });
    }
    this._trackingNodes = [];
  },
  computed: {
    // hasCoupon() {
    //   return !!this.appliedCoupon;
    // },
    planBaseValue() {
      if (this.payment.type === 'CREDIT_CARD') {
        return (this.plan && this.plan.card && Number(this.plan.card.value)) || 0;
      }
      return (this.plan && this.plan.pix && Number(this.plan.pix.value)) || 0;
    },
    selectedCheckoutItemsTotal() {
      const items = (this.plan && this.plan.checkoutItems) || [];
      if (!Array.isArray(items) || items.length === 0) return 0;
      const set = new Set(this.selectedCheckoutItems || []);
      return items
        .filter(i => i && set.has(i.id))
        .reduce((sum, i) => sum + (Number(i.value) || 0), 0);
    },
    selectedCheckoutItemsNames() {
      const items = (this.plan && this.plan.checkoutItems) || [];
      const set = new Set(this.selectedCheckoutItems || []);
      return items
        .filter(i => i && set.has(i.id))
        .map(i => i.name)
        .join(', ');
    },
    totalBeforeDiscount() {
      return (Number(this.planBaseValue) || 0) + (Number(this.selectedCheckoutItemsTotal) || 0);
    },
    // discountAmount() {
    //   const coupon = this.appliedCoupon || {};
    //   let discount = 0;
    //   if (coupon.discountPercentage) {
    //     discount = this.totalBeforeDiscount * (Number(coupon.discountPercentage) / 100);
    //   } else if (coupon.discountValue) {
    //     discount = Number(coupon.discountValue) || 0;
    //   }
    //   if (discount > this.totalBeforeDiscount) discount = this.totalBeforeDiscount;
    //   if (discount < 0) discount = 0;
    //   return discount;
    // },
    totalAfterDiscount() {
      // Coupons disabled: return base total
      return this.totalBeforeDiscount;
    },
    cardDisplayTotal() {
      return this.totalAfterDiscount;
    },
    pixDisplayTotal() {
      return this.totalAfterDiscount;
    },
    isAuth() {
      return store.getters.isAuthenticated;
    },
    sidebarDisabled() {
      return false;
    }
  },
  watch: {
    'payment.type'(newType) {
      if (newType === 'PIX' && this.step === 'payment') {
        this.register();
      }
    }
  },
  methods: {
    async fetchPlan() {
      this.loadingPlan = true;
      try {
        const plan = await getCheckoutPlan();
        this.plan = plan;
      } catch (err) {
        this.$toast && this.$toast.open({
          message: 'Não foi possível carregar o plano.',
          type: 'error',
          position: 'top-right'
        });
      } finally {
        this.loadingPlan = false;
      }
    },

    async fetchIP() {
      try {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        this.userIP = data.ip || '';
      } catch (err) {
        this.userIP = '';
      }
    },

    async changeStep(step) {
      const isValid = this.formValidation();

      if (!isValid) return;

      if (step === 'payment') {
        this.maybeTrackInitiateCheckout();
      }

      if (this.payment.type === 'PIX') {
        await this.register();
      }

      this.step = step;
    },

    formValidation() {
      const { account } = this;

      if (!account.name) {
        this.$toast.open({
          message: 'Nome obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.email) {
        this.$toast.open({
          message: 'Email obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.phoneNumber) {
        this.$toast.open({
          message: 'Telefone obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.email) {
        this.$toast.open({
          message: 'Email obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      return true;
    },

    async register() {
      this.loading = true;
      try {
        const isAuth = store.getters.isAuthenticated;
        const account = {
          ...this.account,
          number: this.account.streetNumber,
        };

        let planId = this.plan && this.plan.id;
        if (this.payment.type === 'CREDIT_CARD' && this.plan && this.plan.card && this.plan.card.id) {
          planId = this.plan.card.id;
        } else if (this.payment.type === 'PIX' && this.plan && this.plan.pix && this.plan.pix.id) {
          planId = this.plan.pix.id;
        }

        const data = {
          account: isAuth ? null : account,
          planId,
          creditCard: {
            holderName: this.payment.name,
            number: this.payment.number,
            expiryMonth: this.payment.expiryMonth,
            expiryYear: this.payment.expiryYear,
            ccv: this.payment.ccv
          },
          creditCardHolderInfo: {
            name: account.name,
            email: account.email,
            cpfCnpj: account.cpf,
            postalCode: account.zipcode,
            addressNumber: account.streetNumber,
            addressComplement: `${account.neighborhood} ${account.street}`,
            phone: account.phoneNumber,
            mobilePhone: ''
          },
          password: isAuth ? null : this.account.password,
          installmentNumber: this.installments,
          IP: this.userIP,
          // couponName disabled while coupon logic is off
          couponName: null,
          checkoutItemsIds: this.selectedCheckoutItems || [],
        };

        const response = await axios.post('/checkout', data);

        this.$toast && this.$toast.open({
          message: 'Cadastro finalizado com sucesso!',
          type: 'success',
          position: 'top-right'
        });

        if (this.payment.type !== 'PIX') {
          // Cartao/assinatura: pagamento confirmado no momento do submit.
          // Disparar Purchase para o Meta Pixel com valor real.
          // (PIX nao dispara aqui — QR code gerado != pagamento confirmado.
          //  Purchase real do PIX deve vir via webhook/Conversions API
          //  numa PR futura.)
          try {
            const purchaseValue = Number(this.totalBeforeDiscount) || 0;
            const purchaseIds = [];
            if (this.plan && this.plan.id) purchaseIds.push(this.plan.id);
            (this.selectedCheckoutItems || []).forEach(id => purchaseIds.push(id));
            this.$fbqTrack('Purchase', {
              value: purchaseValue,
              currency: 'BRL',
              content_ids: purchaseIds,
              content_name: (this.plan && this.plan.name) || undefined,
              content_type: 'product',
              num_items: purchaseIds.length || 1,
            });
          } catch (e) { /* no-op — nao bloqueia fluxo */ }

          this.$router.push('/login');
        } else {
          this.paymentInfo = response.data.subscription;
        }

        return response.data;
      } catch (err) {
        const message = err?.response?.data?.errorMessage || err?.message || 'Erro ao finalizar cadastro';
        this.$toast && this.$toast.open({
          message,
          type: 'error',
          position: 'top-right'
        });
      } finally {
        this.loading = false;
      }
    },

    // removeCoupon() {
    //   if (this.appliedCoupon) {
    //     this.appliedCoupon = null;
    //     this.$toast && this.$toast.open({
    //       message: 'Cupom removido.',
    //       type: 'info',
    //       position: 'top-right'
    //     });
    //   }
    // },

    // getDiscountedValue(base) {
    //   const coupon = this.appliedCoupon || {};
    //   let discounted = base;
    //   if (coupon.discountPercentage) {
    //     discounted = base - (base * (coupon.discountPercentage / 100));
    //   } else if (coupon.discountValue) {
    //     discounted = base - coupon.discountValue;
    //   }
    //   if (discounted < 0) discounted = 0;
    //   return discounted;
    // },

    // async applyCoupon() {
    //   const name = (this.coupon || '').trim();
    //   if (!name) {
    //     this.$toast && this.$toast.open({
    //       message: 'Informe um cupom.',
    //       type: 'error',
    //       position: 'top-right'
    //     });
    //     return;
    //   }
    //
    //   try {
    //     const coupon = await checkCoupon(name);
    //
    //     if (this.appliedCoupon && this.appliedCoupon.name !== coupon.name) {
    //       this.$toast && this.$toast.open({
    //         message: 'Cupom anterior removido.',
    //         type: 'info',
    //         position: 'top-right'
    //       });
    //     }
    //
    //     this.appliedCoupon = coupon;
    //
    //     this.$toast && this.$toast.open({
    //       message: 'Cupom aplicado!',
    //       type: 'success',
    //       position: 'top-right'
    //     });
    //   } catch (err) {
    //     const message = err?.response?.data?.message || 'Cupom não encontrado';
    //     this.appliedCoupon = null;
    //     this.$toast && this.$toast.open({
    //       message,
    //       type: 'error',
    //       position: 'top-right'
    //     });
    //   }
    // },

    formatMoney(value, digits) {
      const d = digits !== undefined ? digits : 2;
      const nf = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: d,
        maximumFractionDigits: d,
      });
      return nf.format(value);
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.$toast && this.$toast.open({
        message: 'Código copia e cola copiado.',
        type: 'info',
        position: 'bottom-right',
      });
    },
    maybeTrackInitiateCheckout() {
      if (this._initiatedCheckoutTracked) return;
      this._initiatedCheckoutTracked = true;
      this.trackInitiateCheckout();
    },
    trackInitiateCheckout() {
      try {
        const value = Number(this.totalBeforeDiscount) || 0;
        const selectedIds = [];
        if (this.plan && this.plan.id) selectedIds.push(this.plan.id);
        try {
          const items = (this.plan && this.plan.checkoutItems) || [];
          const set = new Set(this.selectedCheckoutItems || []);
          items.forEach(i => {
            if (i && set.has(i.id)) selectedIds.push(i.id);
          });
        } catch (e) {}

        // Usa o helper global do plugin metaPixel ($fbqTrack eh no-op
        // se VUE_APP_META_PIXEL_ID nao estiver setado ou ad-blocker
        // estiver ativo).
        this.$fbqTrack('InitiateCheckout', {
          value,
          currency: 'BRL',
          num_items: 1 + ((this.selectedCheckoutItems && this.selectedCheckoutItems.length) || 0),
          content_ids: selectedIds,
          content_name: (this.plan && this.plan.name) || undefined,
        });

        // GA4
        // if (window.gtag) {
        //   window.gtag('event', 'begin_checkout', {
        //     currency: 'BRL',
        //     value,
        //     items: [
        //       {
        //         item_id: (this.plan && this.plan.id) || undefined,
        //         item_name: (this.plan && this.plan.name) || undefined,
        //         quantity: 1,
        //       },
        //     ],
        //   });
        // }
      } catch (e) {
      }
    },
    injectGtm(containerId) {
      try {
        if (window.google_tag_manager) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const script = document.createElement('script');
        script.id = 'gtm-lib';
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId;
        document.head.appendChild(script);
        this._trackingNodes.push(script);
      } catch (e) {
      }
    },
    injectGa4(measurementId) {
      try {
        if (!window.gtag) {
          const gaLib = document.createElement('script');
          gaLib.id = 'ga4-lib';
          gaLib.async = true;
          gaLib.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
          document.head.appendChild(gaLib);
          this._trackingNodes.push(gaLib);
          const gaInline = document.createElement('script');
          gaInline.id = 'ga4-inline';
          gaInline.innerHTML =
            "window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config','" +
            measurementId +
            "');";
          document.head.appendChild(gaInline);
          this._trackingNodes.push(gaInline);
        } else {
          window.gtag('config', measurementId);
        }
      } catch (e) {
      }
    },
    // initFacebookPixel removido — migrado para o plugin metaPixel.js
    // (Vue.prototype.$fbqTrack). Init usa VUE_APP_META_PIXEL_ID,
    // PageView eh disparado em router.afterEach (main.js).
  },
  
  components: {
    Footer,
    TermsAndConditions
  }
}
</script>

<style>
@media screen and (max-width: 768px) {
  .challenge-mobile {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

.bg-challenge-dark {
  background: #000;
  min-height: 100vh;
}

.challenge-card {
  background: #1E1E1E !important;
  border-color: #2a2a2a !important;
  color: #fff;
}

.challenge-form-control {
  background-color: #1E1E1E !important;
  border: 1px solid #333 !important;
  color: #fff !important;
}
.challenge-form-control::placeholder { color: #bbb; }

.challenge-copy-and-paste {
  color: #B5B5C3;
  cursor: pointer;
}
.challenge-single-price {
  text-align: center;
  background: #1E1E1E;
  transition: .7s;
  margin-top: 20px;
}
.challenge-single-price h3 {
  font-size: 25px;
  color: #fff;
  font-weight: 600;
  text-align: center;
  margin: 0;
  margin-top: -80px;
  font-family: poppins;
}
.challenge-single-price h4 {
  font-size: 48px;
  font-weight: 500;
  color: #fff;
}
.challenge-single-price h4 span.sup {
  vertical-align: text-top;
  font-size: 25px;
}
.challenge-deal-top {
  position: relative;
  background: #111 !important;
  font-size: 16px;
  text-transform: uppercase;
  padding: 136px 24px 0;
}
.challenge-deal-top::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -50px;
  width: 0;
  height: 0;
  border-top: 50px solid #111;
  border-left: 175px solid transparent;
  border-right: 170px solid transparent;
}
.challenge-deal-bottom {
  padding: 56px 16px 0;
}
.challenge-deal-bottom ul {
  margin: 0;
  padding: 0;
}
.challenge-deal-bottom  ul li {
  font-size: 16px;
  color: #ddd;
  font-weight: 300;
  margin-top: 16px;
  border-top: 1px solid #2a2a2a;
  padding-top: 16px;
  list-style: none;
}
.challenge-btn-area a {
  display: inline-block;
  font-size: 18px;
  color: #fff;
  background: #333;
  padding: 8px 64px;
  margin-top: 32px;
  border-radius: 4px;
  margin-bottom: 40px;
  text-transform: uppercase;
  font-weight: bold;
  text-decoration: none;
}

.challenge-text { color: #B5B5C3; }

.challenge-single-price:hover {
  background: #1E1E1E;
}
.challenge-single-price:hover .challenge-deal-top {
  background: #111;
}
.challenge-single-price:hover .challenge-deal-top:after {
  border-top: 50px solid #111;
}
.challenge-single-price:hover .challenge-btn-area a {
  background: #111;
}

.challenge-description {
  margin-left: 1rem;
  color: #B5B5C3;
  text-align: left;
  font-weight: 200;
  line-height: 1.25rem;
  margin-bottom: 20px;
}

.challenge-plan-title {
  margin-left: 5px;
  color: #F1F3F5;
}

.challenge-price-text-1 {
  line-height: normal;
  font-size: .75rem;
  text-align: left;
  color: #B5B5C3;
}

.challenge-price-text-2 {
  line-height: 40px;
  font-size: 30px;
  text-align: left;
  color: #F1F3F5;
}

.challenge-form-heading {
  box-sizing: border-box;
  margin: 10px;
  flex: 3.5 0 0%;
  font-weight: bolder;
  line-height: 24px;
  font-size: 17px;
  text-transform: uppercase;
  color: #F1F3F5;
}

.challenge-payment-select {
  padding: 8px 16px 8px 8px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 5%;
  background-color: #1E1E1E;
  color: #fff;
}
/* Title and text color scheme */
.challenge-h1 { color: #F1F3F5; }
.challenge-title { color: #F1F3F5; }
.challenge-label { color: #B5B5C3; }
.challenge-info { display: inline-block; margin-left: 6px; padding: 0 6px; border: 1px solid #B5B5C3; border-radius: 50%; font-weight: 700; cursor: help; color: #B5B5C3; }

.challenge-side-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 6px;
}
.challenge-top-spacer {
  height: 72px;
}

/* Sidebar plan header typography */
.challenge-side-plan-name {
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: #F1F3F5;
}
.challenge-side-plan-price {
  margin-top: 4px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #F1F3F5;
}

/* Payment option cards */
.challenge-pay-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background-color: #1E1E1E;
  border-radius: 8px;
  color: #B5B5C3;
  cursor: pointer;
  transition: border-color .2s ease, box-shadow .2s ease, color .2s ease, background-color .2s ease;
  user-select: none;
}
.challenge-pay-option:hover {
  border-color: #3b82f6;
  color: #F1F3F5;
}
.challenge-pay-option.active {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6 inset, 0 4px 10px rgba(0,0,0,0.35);
  color: #F1F3F5;
  background-color: #161616;
}
.challenge-pay-icon svg {
  width: 24px;
  height: 24px;
}
.challenge-pay-text {
  font-weight: 600;
}

/* Addons highlight */
.challenge-addons-label {
  color: #FFA94D;
  font-weight: 700;
}
.challenge-addon {
  display: block;
  padding: 8px 12px;
  margin-bottom: 6px;
  border: 1px solid rgba(255, 169, 77, 0.35);
  border-radius: 6px;
  background-color: rgba(255, 169, 77, 0.08);
}
.challenge-addon, .challenge-addon .custom-control-label, .challenge-addon-text {
  color: #FFA94D !important;
  font-weight: 600;
}
.challenge-addon .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #FFA94D;
  background-color: rgba(255, 169, 77, 0.15);
}
.challenge-addon .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(255, 169, 77, 0.25);
  border-color: #FFA94D;
}
.challenge-addon .custom-control-label {
  padding-left: 2rem;
}
.challenge-addon .custom-control-label::before,
.challenge-addon .custom-control-label::after {
  left: -5px;
  top: 50%;
  transform: translateY(-50%);
}
</style>


